import environment from "environment";
import { callServer } from '../utils/request-util.js';

export const getHistoryReports = () => {
  return new Promise((resolve, reject) => {
    callServer({
      url: environment.backendAPI + "reportManager",
      method: "GET",
      roles: [
        environment.USER_ROLES.all,
      ]
    }).then(response => resolve(response), error => reject(error.response));
  });
}

export const deleteHistoryReports = (id) => {
  return new Promise((resolve, reject) => {
    callServer({
      url: environment.backendAPI + `reportManager/${id}`,
      method: "DELETE",
      roles: [
        environment.USER_ROLES.all,
      ]
    }).then(response => resolve(response), error => reject(error.response));
  });
}

export const getHistoryReportById = (id) => {
  return new Promise((resolve, reject) => {
    callServer({
      url: environment.backendAPI + `reportManager/${id}`,
      method: "GET",
      roles: [
        environment.USER_ROLES.all,
      ]
    }).then(response => resolve(response), error => reject(error.response));
  });
}

export const addHistoryReport = (body) => {
  return new Promise((resolve, reject) => {
    callServer({
      url: environment.backendAPI + `reportManager`,
      method: "POST",
      data: body,
      roles: [
        environment.USER_ROLES.all,
      ]
    }).then(response => resolve(response), error => reject(error.response));
  });
}

export const getReportById = (reportId) => {
  return new Promise((resolve, reject) => {
    callServer({
      url: environment.backendAPI + `reportManager/${reportId}`,
      method: "POST",
      responseType: "blob",
      roles: [
        environment.USER_ROLES.all,
      ]
    }).then(response => resolve(response), error => reject(error.response));
  });
}

export const sendDepotAutomatedReport = (depotId, recurrencyType) => {
  return new Promise((resolve, reject) => {
    callServer({
      url: environment.backendAPI + "reportManager/sendDepotAutomatedReport",
      method: "POST",
      data: {
        DepotId: depotId,
        RecurrencyType: recurrencyType,
      },
      roles: [
        environment.USER_ROLES.all,
      ]
    }).then(response => resolve(response), error => reject(error.response));
  });
}